import React, { useContext, useEffect } from 'react';
import { UserSessionContext } from '@common/context/UserSessionContext/UserSessionContext';
import useAuthRedirect from '@common/hooks/useAuthRedirect';

type Props = {
  children: React.ReactNode;
  onSessionSet?: (loaded: boolean) => void;
}

const DirectRouteWrapper = (props: Props) => {
  const { onSessionSet } = props;
  const session = useContext(UserSessionContext);
  const { clearRedirectOnArrival, redirectToSignIn } = useAuthRedirect();

  useEffect(() => {
		if (session.state === 'NotLoggedIn') {
			// Only redirect once we are SURE the user is not logged in
			console.log('Redirecting to sign in');
			redirectToSignIn();
		} else if (session.state === 'LoggedIn') {
      clearRedirectOnArrival();
      onSessionSet?.(true);
    }
	}, [clearRedirectOnArrival, session.state, redirectToSignIn, onSessionSet]);


	if (session.state === 'NotLoggedIn') {
		return null;
	}

  return props.children;
};

export default DirectRouteWrapper;
